import React from 'react';

import newImage from '../images/new-feature.png';

export function NewIcon() {
  return <img src={newImage} />;
}
